import {
  PLAYER_ERROR_CODES_MAP,
  PIN_CHECK,
  GUIDANCE_TEXT,
  VOD_MESSAGE_TYPES,
} from '../../constants'
import cookies from '../../utils/cookies'

const { PLAYER_ERROR } = VOD_MESSAGE_TYPES

export default function getError({
  episodeResults,
  apiErrorState,
  guidanceTextAccepted,
  hasPin,
  pinAccepted,
  prevAccepted,
  playerError,
}) {
  if (apiErrorState) return PLAYER_ERROR_CODES_MAP[apiErrorState.code]

  if (playerError) return PLAYER_ERROR

  if (episodeResults?.hasGuidanceText) {
    if (hasPin && !pinAccepted) return PIN_CHECK
    if (!hasPin && !guidanceTextAccepted) {
      const { guid } = episodeResults?.programme || {}
      // remove any previously set guidance acceptance if we're not coming from EoP
      cookies.remove(guid)
      if (!prevAccepted) {
        return GUIDANCE_TEXT
      }
    }
  }

  return null
}
